import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";

// Common components
import CustomizedSwitches from "@Layouts/components/InputComponents/CustomizedSwitches";

function SwitchToolbar(props) {
	const { apiRef, data, checked, searchIn, searchValue, onChange } = props;
	const [active, setActive] = useState(false);

	const handleSwitchChange = () => {
		setActive(!active);
		onChange?.(!active);
	};

	useMemo(() => {
		const filter = searchValue || "";
		setTimeout(() => {
			apiRef.current.setRows(data || []);
			if (active && filter && searchIn) {
				const filtered = data?.filter((row) => {
					if (row?.id === "new_table_row_item" || row?._id === "new_table_row_item") {
						return true;
					}
					return row?.[searchIn] === filter;
				});
				apiRef.current.setRows(filtered);
			}
		});
	}, [apiRef, data, searchValue, searchIn, active]);

	useEffect(() => {
		setActive(Boolean(checked));
		return () => {
			setActive(false);
		};
	}, [checked]);

	return <CustomizedSwitches {...props} onChange={handleSwitchChange} />;
}
SwitchToolbar.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	data: PropTypes.array,
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	hide: PropTypes.bool,
	searchIn: PropTypes.string,
	searchValue: PropTypes.string,
	textRight: PropTypes.bool,
	textChecked: PropTypes.string,
	textUnChecked: PropTypes.string,
	onChange: PropTypes.func,
};

export default SwitchToolbar;
